import { ForgottenPasswordPage } from 'pages/ForgottenPasswordPage';
import { LoginPage } from 'pages/LoginPage';
import { MyAccountPage } from 'pages/MyAccountPage';
import { RegisterPage } from 'pages/RegisterPage';
import { ResellerPage } from 'pages/ResellerPage';
import { SetNewPasswordPage } from 'pages/SetNewPasswordPage';
import { VerifyEmailPage } from 'pages/VerifyEmailPage';
import { Route } from 'react-router-dom';

export default [
    //login flow
    <Route path="/login" element={<LoginPage />} key="301" />,
    <Route path="/register" element={<RegisterPage />} key="302" />,
    <Route path="/forgotten-password" element={<ForgottenPasswordPage />} key="303" />,
    <Route path="/set-new-password" element={<SetNewPasswordPage />} key="304" />,
    <Route path="/verify-email" element={<VerifyEmailPage />} key="305" />,
    //logged in
    <Route path="/reseller" element={<ResellerPage />} key="306" />,
    <Route path="/account" element={<MyAccountPage />} key="307" />
];
